/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template lang="pug">
    div(v-bind:class="['forgot-password-section', amplifyUI.formSection,  errored ? 'errored' : 'normal']" v-bind:data-test="auth.forgotPassword.section")
      div(v-bind:class="amplifyUI.sectionHeader" v-bind:data-test="auth.forgotPassword.headerSection") {{options.header}}
      div(v-bind:class="['forgot-password-body-section', amplifyUI.sectionBody]" v-bind:data-test="auth.forgotPassword.bodySection")
        div(v-bind:class="[amplifyUI.formField, 'forgot-password']")
          div(v-bind:class="[amplifyUI.inputLabel, 'label']") {{$Amplify.I18n.get('Username')}}
          input(spellcheck="false" v-bind:class="amplifyUI.input" v-model="username" :placeholder="$Amplify.I18n.get('Enter your username')" autofocus="" v-bind:data-test="auth.forgotPassword.usernameInput")
        div(v-bind:class="amplifyUI.formField" v-if="sent")
          div(v-bind:class="[amplifyUI.inputLabel, 'label']" style="mrgin-top: 10px; margin-bottom: -10px") {{$Amplify.I18n.get('Code')}}
          v-otp-input(:ref="'otpInput'" :input-classes="'otp-input'" :separator="'&nbsp;'" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange" @on-complete="handleOnComplete"  v-bind:class="amplifyUI.input" :placeholder="$Amplify.I18n.get('Code')" v-bind:data-test="auth.forgotPassword.codeInput" )
        div(v-bind:class="amplifyUI.formField" v-if="sent")
          div(v-bind:class="[amplifyUI.inputLabel, 'label']") {{$Amplify.I18n.get('New Password')}} *
          password(v-bind:class="amplifyUI.input" v-model="password" type="password" v-bind:data-test="auth.forgotPassword.newPasswordInput" :placeholder="$Amplify.I18n.get('New Password')" autofocus="" :secure-length="8" :toggle="false")
      div(v-bind:class="[amplifyUI.sectionFooter, 'forgot-footer']")
        span(v-bind:class="amplifyUI.sectionFooterPrimaryContent")
          button(v-if="!sent" v-bind:class="amplifyUI.button" v-on:click="submit" :disabled="!(username && username.length >=4)" v-bind:data-test="auth.forgotPassword.sendCodeButton")
            geno-spinner(:loading="flow" :text="$Amplify.I18n.get('Send Code')" :size="32")
          button(v-if="sent" v-bind:class="amplifyUI.button" v-on:click="verify" :disabled="!(username && username.length >= 4 && code && code.length == 6 && password && password.length >= 8)" v-bind:data-test="auth.forgotPassword.submitButton")
            geno-spinner(:loading="flow" :text="$Amplify.I18n.get('Submit')" :size="32")
      .error(v-if="false")
        | {{ error }}
      div(class="recover-username" v-if="!sent")
        div.bottom(v-bind:class="amplifyUI.sectionHeader" v-bind:data-test="auth.forgotPassword.headerSection") or {{options.recover}}
        div(v-bind:class="['forgot-password-body-section', amplifyUI.sectionBody]" v-bind:data-test="auth.forgotPassword.bodySection")
          div(v-bind:class="[amplifyUI.formField, 'forgot-username']")
            div(v-bind:class="[amplifyUI.inputLabel, 'label']") {{$Amplify.I18n.get('Email')}}
            input(spellcheck="false" v-bind:class="amplifyUI.input" v-model="email" :placeholder="$Amplify.I18n.get('Enter your email')" autofocus="" v-bind:data-test="auth.signUp.nonPhoneNumberInput")
        div(v-bind:class="[amplifyUI.sectionFooter, 'forgot-footer']")
          span(v-bind:class="amplifyUI.sectionFooterPrimaryContent")
            button(v-if="!sent" v-bind:class="amplifyUI.button" v-on:click="send" :disabled="!email" v-bind:data-test="auth.forgotPassword.sendCodeButton")
              geno-spinner(:loading="flow2" :text="$Amplify.I18n.get('Send Username')" :size="32")
      span(v-bind:class="[amplifyUI.sectionFooterSecondaryContent, 'back-to-signin']")
        a(vif="!sent" v-bind:class="amplifyUI.a" v-on:click="signIn" v-bind:data-test="auth.forgotPassword.backToSignInLink") {{$Amplify.I18n.get('Back to Sign In')}}
        //a(v-if="sent" v-bind:class="amplifyUI.a" v-on:click="submit" v-bind:data-test="auth.forgotPassword.resentCodeLink") {{$Amplify.I18n.get('Resend Code')}}
</template>

<script>
// <input spellcheck="false" v-bind:class="amplifyUI.input" v-model="password" type="password" :placeholder="$Amplify.I18n.get('New Password')" autofocus v-bind:data-test="auth.forgotPassword.newPasswordInput" />
import AmplifyEventBus from '../../events/AmplifyEventBus';
import * as AmplifyUI from '@aws-amplify/ui';
import { auth } from '../../assets/data-test-attributes';
const Password = () => import('@/components/PasswordStrengthMeter.vue')
import otpInput from "@/components/vue-otp-input";

export default {
  name: 'ForgotPassword',
  props: ['forgotPasswordConfig'],
  components: { Password },
  data () {
    return {
        username: '',
        flow: false,
        flow2: false,
        code: '',
        password: '',
        errored: false,
				email: '',
        error: "passwords require mixed case letters, numbers and a special character, minimum length is 8",
        sent: false,
        logger: {},
        amplifyUI: AmplifyUI,
        auth
    }
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get('Reset your password'),
        recover: this.$Amplify.I18n.get('Recover your username'),
      }
      return Object.assign(defaults, this.forgotPasswordConfig || {})
    }
  },
  mounted() {
  this.errored = false
      AmplifyEventBus.$emit('loginErrors', { source: 'forgotPassword', error: this.error})
    this.logger = new this.$Amplify.Logger(this.$options.name)
  },
  methods: {
    handleOnComplete(value) {
			this.code = value
    },
    handleOnChange(value) {
			this.code = value
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
			this.code = null;
    },
		send: function() {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email))
      {
      this.flow2 = true
      const that = this
      this.$Amplify.Auth.signIn('sendUserNameToUser', '#############', { email: this.email})
        .then(data => {
          this.flow2 = false
      this.errored = false
          this.$modal.hide('login');
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: "Thank You",
                            text: 'You should receive an email with your username shortly!<br>Please check your mailbox for a message from <a style="text-decoration: none;"  href="mailto: support@genoplot.com" target="_blank">Genoplot Support</a>',
                            class: 'alert'
                        }
                    })
        })
        .catch((e) => {
          this.flow2 = false
          this.$modal.hide('login');
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: "Thank You",
                            text: 'You should receive an email with your username shortly!<br>Please check your mailbox for a message from <a style="text-decoration: none;"  href="mailto: support@genoplot.com" target="_blank">Genoplot Support</a>',
                            class: 'alert'
                        }
                    })
          return (true)
          })
            } else {
      this.error = 'invalid email address';
                    return (false)
                    }
		},
    submit: function() {
      this.flow = true;
      this.$Amplify.Auth.forgotPassword(this.username)
        .then(() => {
      this.errored = false
      this.flow = false;
          this.sent = true;
          this.error = "passwords require uppercase letters, lowercase letters plus a special character, minimum length is 8";
          this.logger.info('forgotPassword success');
        })
        .catch(e => {
      this.flow = false;
        this.setError(e)
        });
    },
    verify: function() {
      this.flow = true;
      this.$Amplify.Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(() => {
      this.errored = false
      this.flow = false;
          this.logger.info('forgotPasswordSubmit success');
          AmplifyEventBus.$emit('authState', 'signIn');
        })
        .catch(e =>  {
      this.flow = false;
      this.handleClearInput()
      this.errored = true;
        this.setError(e)
        });
    },
    signIn: function() {
      AmplifyEventBus.$emit('authState', 'signIn');
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.errored = true
      let loginErrors = e.message || e
      try {
      loginErrors = loginErrors.replace(/^.*failed with error/,'')
      }
      catch(err) {
      }
      AmplifyEventBus.$emit('loginErrors', { source: 'forgotPassword', error: loginErrors})
      this.logger.error(this.error);
    }
  },
	components: {
	'v-otp-input': otpInput,
  Password
	}
}
</script>
<style>
#auth > div > div.bottom.Section__sectionHeader___2djyg {
margin-top: 25px;
}
</style>
